import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';
import {NavService} from '../../../../services/nav.service';
import {NavItemCodes} from '../../../../enums/nav-item-codes.enum';


@Component({
    selector: 'app-nav-button',
    templateUrl: './nav-button.component.html',
})
export class NavButtonComponent implements OnChanges {
    @Input() item: NavItem;
    @Input() code: NavItemCodes;
    @Input() label: string;
    @Input() type: 'primary' | 'dashed' | 'link' | 'text' = 'link';
    @Input() payload: any;

    constructor(
        private navService: NavService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.code) {
            this.item = NavService.get(this.code);
        }
    }

    onClick() {
        if (this.item) {
            this.navService.handleDispatch(this.item, this.payload);
        }
    }
}
